module.exports = "/_next/static/images/David_Sumner-8417b9d60653c6ee09434e6c47d0e317.webp";